import classnames from 'classnames';
import { Icon } from 'common/components/icons/Icon';
import type { AllIconNames } from './icons/icons';

type Props = {
  title?: string;
  children?: React.ReactNode;
  className?: string;
  icon?: AllIconNames;
  label?: string;
  labelClass?: string;
};
export const MainTitle = ({
  title = '',
  children = null,
  className = '',
  icon = undefined,
  label = '',
  labelClass = '',
}: Props) => {
  const mainClasses = classnames('main-title-container', className);
  const labelClassName = classnames('title-label', labelClass);
  return (
    <div className={mainClasses}>
      {title && (
        <h2 className="main-title">
          {icon && <Icon name={icon} />}
          {title}
          {children}
          {label && <div className={labelClassName}>{label}</div>}
        </h2>
      )}
    </div>
  );
};
